// 区域环保管家
<template>
  <div class="ehsemapwrap">
    <!-- <div class="menuCover"></div> -->
    <div class="menuLine" v-if="switchMenuF">
      <div class="menuItem" :class="{'menuItem-active': subType == 'areaIntros'}"
        @click="showMenuSubLine('areaIntros')">区域总览</div>
      <div class="menuItem" :class="{'menuItem-active': subType == 'monitors'}"
        @click="showMenuSubLine('monitors')">视频管理</div>
      <div class="menuItem" :class="{'menuItem-active': subType == 'pollutionSrcs'}"
        @click="showMenuSubLine('pollutionSrcs')">污染源管理</div>
      <div class="menuItem" :class="{'menuItem-active': subType == 'enStaffs'}"
        @click="toEnStaffs()">环保职员</div>
      <div class="menuItem" :class="{'menuItem-active': subType == 'dataMng' || subType == 'enStDataMng'}"
        @click="showMenuSubLine('mngs')">数据管理</div>
    </div>
    <div class="menuLine" v-else>
      <div class="menuItem" @click="showMenuSubLine('')">返回上一级</div>
      <div class="menuItem" v-for="(item, index) in subMenuLineData" :key="index"
        @click="clickMenuSubItem(item.id)">{{ item.name }}
      </div>
    </div>
    <!-- <div class="dropdownLine">
      <el-dropdown>
        <span :class="{'el-dropdown-link': subType == 'areaIntros', 'el-dropdown-link-unselected': subType != 'areaIntros'}">
          区域总览<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in areaIntros"
            :key="index"
            @click.native="toSubAreaIntro(index)">
            {{item.name}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <span :class="{'el-dropdown-link': subType == 'pollutionSrcs', 'el-dropdown-link-unselected': subType != 'pollutionSrcs'}">
          污染源管理<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in pollutionSrcs"
            :key="index"
            @click.native="toSubSource(item.id)">
            {{item.name}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <span :class="{'el-dropdown-link': subType == 'enStaffs', 'el-dropdown-link-unselected': subType != 'enStaffs'}">
          环保职员<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="toEnStaffs()">
            环保职员
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <span :class="{'el-dropdown-link': subType == 'dataMng' || subType == 'enStDataMng', 'el-dropdown-link-unselected': subType != 'dataMng' || subType != 'enStDataMng'}">
          数据管理<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="toDataMng()">
            污染源数据管理
          </el-dropdown-item>
          <el-dropdown-item
            @click.native="toStaffDataMng()">
            环保职员数据管理
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <span :class="{'el-dropdown-link': subType == 'monitors', 'el-dropdown-link-unselected': subType != 'monitors'}">
          视频管理<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in monitors"
            :key="index"
            @click.native="toSubMonitors(index)">
            {{item.name}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
    <div class="ehspages">
      <div class="ehssubpages" v-if="subType == 'areaIntros' && activeTab == 'home'">
        <ehsHome></ehsHome>
      </div>
      <div class="ehssubpages" v-if="subType == 'areaIntros' && activeTab != 'home'">
        <ehsAreaOverview :activeTab="activeTab" :subType="subType"></ehsAreaOverview>
      </div>
      <div class="ehssubpages" v-if="subType == 'monitors'">
        <ehsAreaOverview :activeTab="activeTab" :subType="subType"></ehsAreaOverview>
      </div>
      <div class="ehssubpages" v-if="subType == 'pollutionSrcs' || subType == 'dataMng'">
        <ehsPollutionSrcs :pollutionSrcs="pollutionSrcs" :pollutionSrcsTab="pollutionSrcsTab" :subType="subType"></ehsPollutionSrcs>
      </div>
      <div class="ehssubpages" v-if="subType == 'enStaffs' || subType == 'enStDataMng'">
        <ehsEnStaffs :subType="subType"></ehsEnStaffs>
      </div>
    </div>
  </div>
</template>

<script src="https://webapi.amap.com/maps?v=1.4.15&key=0543eba50a73a17425d961a9c939597f"></script>
<script>
/* eslint-disable no-undef */
// import myTitle from '@/components/myTitle.vue'
import ehsAreaOverview from '../ehs-com/ehsAreaOverview.vue'
import ehsPollutionSrcs from '../ehs-com/ehsPollutionSrcs.vue'
import ehsEnStaffs from '../ehs-com/ehsEnStaffs.vue'
import ehsHome from '../ehs-com/ehsHome.vue'
import axios from 'axios'
// import config from '../config/index.js'
// import api from '../api/index'
export default {
  data () {
    return {
      areaIntros: [{
        id: 0,
        name: '首页'
      }, {
        id: 1,
        name: '地图总览'
      }, {
        id: 2,
        name: '大气监控'
      }, {
        id: 3,
        name: '水质监控'
      }, {
        id: 4,
        name: '用电监控'
      }, {
        id: 5,
        name: '用水监控'
      }],
      pollutionSrcs: [{
        id: 0,
        name: '基本信息'
      }, {
        id: 1,
        name: '环评验收'
      }, {
        id: 2,
        name: '排污许可'
      }, {
        id: 3,
        name: '用电工况'
      }, {
        id: 4,
        name: '用水工况'
      }, {
        id: 5,
        name: '环保耗材'
      }, {
        id: 6,
        name: '环境应急'
      }, {
        id: 7,
        name: '清洁生产'
      }, {
        id: 8,
        name: '行政处罚'
      }, {
        id: 9,
        name: '信访投诉'
      }, {
        id: 10,
        name: '环境监察'
      }, {
      //   id: 11,
      //   name: '环保职员'
      // }, {
        id: 12,
        name: '环保管家'
      // }, {
      //   id: 13,
      //   name: '巡查任务'
      }],
      monitors: [{
        id: 1,
        name: '地图总览'
      }, {
        id: 2,
        name: '大气监控'
      }, {
        id: 3,
        name: '水质监控'
      }, {
        id: 4,
        name: '用电监控'
      }, {
        id: 5,
        name: '用水监控'
      }],
      mngs: [{
        id: 0,
        name: '污染源数据管理'
      }, {
        id: 1,
        name: '环保职员数据管理'
      }],
      subMenuLineData: [],
      switchMenuF: true,
      subMenuType: '',
      subType: 'areaIntros',
      activeTab: 'map',
      pollutionSrcsTab: 0
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    toSubAreaIntro (num) {
      this.subType = '!areaIntros'
      this.$nextTick(function () {
        this.subType = 'areaIntros'
        console.log(this.subType + num)
        switch (num) {
          case 0:
            this.activeTab = 'home'
            break
          case 1:
            this.activeTab = 'map'
            break
          case 2:
            this.activeTab = 'atmos'
            break
          case 3:
            this.activeTab = 'water'
            break
          case 4:
            this.activeTab = 'uelectro'
            break
          case 5:
            this.activeTab = 'uwater'
            break
        }
      })
    },
    toSubSource (num) {
      this.subType = '!pollutionSrcs'
      this.$nextTick(function () {
        this.subType = 'pollutionSrcs'
        this.pollutionSrcsTab = num
        console.log(this.subType + num)
      })
    },
    toEnStaffs () {
      this.subType = '!enStaffs'
      this.$nextTick(function () {
        this.subType = 'enStaffs'
        console.log(this.subType)
      })
    },
    toDataMng () {
      this.subType = '!dataMng'
      this.$nextTick(function () {
        this.subType = 'dataMng'
        console.log(this.subType)
      })
    },
    toStaffDataMng () {
      this.subType = '!enStDataMng'
      this.$nextTick(function () {
        this.subType = 'enStDataMng'
        console.log(this.subType)
      })
    },
    toSubMonitors (num) {
      this.subType = '!monitors'
      this.$nextTick(function () {
        this.subType = 'monitors'
        console.log(this.subType + num)
        switch (num) {
          case 1:
            this.activeTab = 'map'
            break
          case 2:
            this.activeTab = 'atmos'
            break
          case 3:
            this.activeTab = 'water'
            break
          case 4:
            this.activeTab = 'uelectro'
            break
          case 5:
            this.activeTab = 'uwater'
            break
        }
      })
    },
    toSubMngs (num) {
      switch (num) {
        case 0:
          this.toDataMng()
          break
        case 1:
          this.toStaffDataMng()
          break
      }
    },
    showMenuSubLine (type) {
      this.switchMenuF = !this.switchMenuF
      this.subMenuType = type
      switch (type) {
        case 'areaIntros':
          this.subMenuLineData = this.areaIntros
          break
        case 'monitors':
          this.subMenuLineData = this.monitors
          break
        case 'pollutionSrcs':
          this.subMenuLineData = this.pollutionSrcs
          break
        case 'mngs':
          this.subMenuLineData = this.mngs
          break
      }
    },
    clickMenuSubItem (index) {
      switch (this.subMenuType) {
        case 'areaIntros':
          this.toSubAreaIntro(index)
          break
        case 'monitors':
          this.toSubMonitors(index)
          break
        case 'pollutionSrcs':
          this.toSubSource(index)
          break
        case 'mngs':
          this.toSubMngs(index)
          break
      }
      this.switchMenuF = !this.switchMenuF
    }
  },
  destroyed () {
  },
  components: {
    ehsAreaOverview,
    ehsPollutionSrcs,
    ehsEnStaffs,
    ehsHome,
    // myTitle,
    axios
    // config,
    // api
  }
}
</script>

<style lang="scss">
.ehsemapwrap{
  z-index: 0;
  height: 100%;
  margin: 0!important;
  .menuCover{
    height: 40px;
    width: 100%;
    z-index: 9999!important;
  }
  .menuCover:hover .menuLine{
    display: none;
  }
  .menuCover:hover{
    background-color: #409eff;
  }
  .menuLine{
    height: 40px;
    width: 100%;
    display: flex;
    .menuItem{
      flex: 1;
      height: 40px;
      // width: 20%;
      background-color: #000f1f;
      color: #007fff;
      border: #002f5f 1px solid;
      text-align: center;
      font-size: 20px;
      font-weight: bolder;
      line-height: 40px;
    }
    .menuItem-active{
      background-color: #003f7f;
      color: #e0f0ff;
    }
    :hover {
      background-color: #002f5f;
    }
  }
  // .menuLine:hover + .menuSubLine{
  //   display: flex;
  // }
  // .menuSubLine{
  //   height: 40px;
  //   width: 100%;
  //   background-color: #003f7f;
  //   display: flex;
  // }
  .dropdownLine{
    margin: 4px 10px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .el-dropdown-link-unselected {
    cursor: pointer;
  }
  .el-dropdown + .el-dropdown {
    margin-left: 15px;
  }
  .ehspages{
    width: 100%;
    height: calc(100% - 40px);
    .ehssubpages{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
